import { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import GlobalContext from "../../../context/GlobalContext";
import { userService } from "../../../services/CommonServices";
import ReactPaginate from 'react-paginate';
import Loader from '../../Loader/Loader';

const ProviderPaymentsList = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const globalData = useContext(GlobalContext);

    const [res, setRes] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [providers, setProviders] = useState([]);
    const [selectedProvider, setSelectedProvider] = useState('');
    const itemsPerPage = 10; // Page size

    const fetchProviders = () => {
        const headers = { Authorization: globalData.token };
        userService.get_providers_ids_and_names_api(headers)
            .then((response) => {
                if (response.status === 200) {
                    setProviders(response.data.data || []);
                }
            })
            .catch((error) => {
                console.error("Error fetching providers:", error);
            });
    };

    const fetchProviderPayments = (page) => {
        setIsLoading(true);
        const headers = { Authorization: globalData.token };
        const query = {
            page,
            size: itemsPerPage,
            providerId: selectedProvider,
        };

        userService.provider_payments_list_api(headers, query)
            .then((response) => {
                if (response.status === 200) {
                    setRes(response.data.data);
                    setTotalItems(response.data.total);
                }
            })
            .catch((error) => {
                console.error("Error fetching provider payments:", error);
                if (error.response?.status === 401) {
                    globalData.set_token("");
                    globalData.set_org_id("");
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('org_id');
                    navigate('/login');
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const applyFilters = () => {
        setCurrentPage(0);
        fetchProviderPayments(0);
    };

    const clearFilters = () => {
        setSelectedProvider('');
        setCurrentPage(0);
        fetchProviderPayments(0);
    };

    const handleProviderChange = (event) => {
        setSelectedProvider(event.target.value);
    };

    useEffect(() => {
        fetchProviders();
    }, []);

    useEffect(() => {
        fetchProviderPayments(currentPage);
    }, [currentPage]);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    const approvePayment = (paymentId) => {
        if (!window.confirm(`Are you sure you want to approve this payment`)) return;

        const headers = { Authorization: globalData.token };
        userService.approve_provider_payment_api(headers, paymentId)
            .then((response) => {
                if (response.status === 200) {
                    alert("Payment approved successfully!");
                    fetchProviderPayments(currentPage); // Refresh the list
                } else {
                    alert("Failed to approve payment.");
                }
            })
            .catch((error) => {
                console.error("Error approving payment:", error);
                alert("Error approving payment. Please try again.");
            });
    };

    return (
        <div className="content_area">
            {isLoading && <Loader />}
            <div className="tables_area">
                <div className="title-box">
                    <h2 className="pull-left">Provider Payments List</h2>
                    <div className="clear"></div>
                </div>

                <div className="filter-box">
                    <div className="filters">
                        <label>Provider</label>
                        <select value={selectedProvider} onChange={handleProviderChange}>
                            <option value="">All Providers</option>
                            {providers.map((provider) => (
                                <option key={provider.id} value={provider.id}>
                                    {provider.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <button onClick={applyFilters}>Apply Filters</button>
                    <button onClick={clearFilters}>Clear Filters</button>
                </div>

                <div className="white_box">
                    <div className="table-responsive">
                        <table width="100%" cellSpacing="0" cellPadding="0">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Provider</th>
                                    <th>Payment Mode</th>
                                    <th>Transaction ID</th>
                                    <th>Amount</th>
                                    <th>File Link</th>
                                    <th>Created At</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {res.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.provider.firstName} {item.provider.lastName}</td>
                                        <td>{item.paymentMode}</td>
                                        <td>{item.transactionId}</td>
                                        <td>{item.amount}</td>
                                        <td>
                                            {item.fileLink ? (
                                                <a href={item.fileLink} target="_blank" rel="noopener noreferrer">
                                                    View
                                                </a>
                                            ) : "N/A"}
                                        </td>
                                        <td>{item.createdAt}</td>
                                        <td>{item.status === 0 ? "Pending" : "Approved"}</td>
                                        <td>
                                            {item.status === 0 && (
                                                <button onClick={() => approvePayment(item.id)}>
                                                    Approve
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={Math.ceil(totalItems / itemsPerPage)}
                    previousLabel="< Previous"
                    renderOnZeroPageCount={null}
                />
            </div>
        </div>
    );
};

export default ProviderPaymentsList;